'use strict';

var PooledParametersDirective = function PooledParametersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pooled-parameters.html'),
    requires: '^rmNewPooledSeasonalityCalendar',
    scope: false
  };
};
PooledParametersDirective.$inject = [];
module.exports = PooledParametersDirective;